module.exports = __webpack_public_path__ + "img/sm2020.adabb385.jpg";